export default __webpack_public_path__ + "static/media/US.fc4620c5.svg";